'use client'

import type { ReactNode } from 'react'

import S from './StatCard.module.scss'

interface StatCardProps {
  label: string
  value: string | number
  icon?: ReactNode
  hasGridBackground?: boolean
}

const StatCard = ({
  label,
  value,
  icon,
  hasGridBackground = false
}: StatCardProps) => {
  return (
    <div className={`${S.card} ${hasGridBackground ? S.cardWithGrid : ''}`}>
      <span className={S.label}>{label}</span>
      <span className={S.value}>{value}</span>
      {icon ? <div className={S.iconBg}>{icon}</div> : null}
    </div>
  )
}

export default StatCard
